export function getUnixTimestampNow() {
  const now = new Date();
  const nowDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    now.getHours(),
    now.getMinutes(),
  );
  return Math.floor(nowDate.getTime() / 1000);
}

export function getDifferenceBetweenUnixTimestampsMilliseconds(
  a: number,
  b: number,
) {
  const diff = a - b;
  const minuteDiff = diff / 60;
  return minuteDiff;
}

export function formatDatetimeAsString(date: Date) {
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();

  const formattedDatetime = `${year}-${
    (month + 1).toString().length === 2
      ? month + 1
      : `0${(month + 1).toString()}`
  }-${day.toString().length === 2 ? day : `0${day}`} ${
    hour < 10 ? `0${hour}` : hour
  }:${minute < 10 ? `0${minute}` : minute}`;

  return formattedDatetime;
}

export function formatDateAsString(date: Date) {
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  const formattedDate = `${year}-${
    (month + 1).toString().length === 2
      ? month + 1
      : `0${(month + 1).toString()}`
  }-${day.toString().length === 2 ? day : `0${day}`}`;

  return formattedDate;
}

export function buildDatetimeObjectFromStringAndNumbers(
  date: string,
  hour: number,
  minute: number,
) {
  const dateParts = date.split("-");
  const year = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10) - 1;
  const day = parseInt(dateParts[2], 10);
  return new Date(year, month, day, hour, minute);
}

export function buildDateObjectFromHourAndMinute(hour: number, minute: number) {
  const now = new Date();
  return new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    hour,
    minute,
  );
}
